import React from "react";
//#region types
import { CustomLinkProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { useNavigate, useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { UrlHelper, UtilsHelper } from "utils/helpers";

const CustomLink: React.FC<CustomLinkProps> = (props) => {
  const { link, displayText, forceReplacingUrl } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const onClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();

    !UtilsHelper.isEmpty(link) &&
      navigate(UrlHelper.formatPath(link), {
        replace: forceReplacingUrl,
        state: { background: location },
      });
  };

  return (
    <Grid item onClick={onClick} className={clsx(cssExports.profileLink, cssExports.truncateString)}>
      {displayText}
    </Grid>
  );
};

export default CustomLink;
